export const APP_NAME = 'TimeRoot'
